module.exports = __webpack_public_path__ + "img/bcha.218ff0bd.svg";